var map = {
	"./gallery-wip-crystal-chamber_00.jpg": 4727,
	"./gallery-wip-crystal-chamber_01.jpg": 4728,
	"./gallery-wip-crystal-chamber_02.jpg": 4729,
	"./gallery-wip-crystal-chamber_03.jpg": 4730,
	"./gallery_00.jpg": 4731,
	"./gallery_01.jpg": 4732,
	"./gallery_02.jpg": 4733,
	"./gallery_03.jpg": 4734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4726;